import React, { Fragment, useState } from 'react';
import { Button, Field, Control, Input, Help, Label, Select } from "rbx";
import { Redirect } from "react-router-dom";
import ProvaService from '../../../services/prova';
import InputMask from "react-input-mask";
import { insProgress } from 'react-ins-progress-bar';
import jwt from 'jwt-decode';
import "../../../styles/login.scss";

function LoginForm() {
    const [error, setError] = useState(false);
    const [tcpf, toggleCpf] = useState(false);
    const [tdoc, toggleDoc] = useState(false);
    const [cpf, setCpf] = useState('');
    const [docEstrangeiro, setDocEstrangeiro] = useState('');
    const [dataNascimento, setDataNascimento] = useState('');
    const [redirectToInicioProva, setRedirectToInicioProva] = useState(false);
    const [response, setResponse] = useState('Dados Inválidos.');

    const selectChange = () => {
        let id = null;
        id = document.getElementById('selectID');
        let value = id.options[id.selectedIndex].value;

        if (value === '1') {
            toggleCpf(true)
        } else {
            toggleCpf(false)
        }
        if (value === '2') {
            toggleDoc(true)
        } else {
            toggleDoc(false)
        }
    }

    const handleSubmit = async (evt) => {
        insProgress.start()
        evt.preventDefault();

        function FormataStringData(data) {
            var dia = data.split("/")[0];
            var mes = data.split("/")[1];
            var ano = data.split("/")[2];
            return ano + '-' + ("0" + mes).slice(-2) + '-' + ("0" + dia).slice(-2);
        }

        let ds_cpf = cpf.replace(/[.-]/g, '')
        const dt_nascimento = FormataStringData(dataNascimento)

        try {
           
            document.getElementById("acessar").disabled = true;
            await ProvaService.login({ ds_cpf: ds_cpf, ds_estrangeiro: docEstrangeiro, dt_nascimento: dt_nascimento });
            
            setTimeout(() => {
                handleInicio();

            }, 1000);
            setTimeout(() => {
                handleGeraProva();
                
            }, 300);

        } catch (error) {
            setError(true)
            document.getElementById("acessar").disabled = false;
        }

        insProgress.finish()
    }

    const handleGeraProva = async (evt) => {
        let teste = localStorage.getItem('token');
        let dados = jwt(teste);
        const id_inscricao = dados.ID_Inscricao;
        let cd_vestibular = 201;

        // ** AJUSTE MASTER PARA FORMATAR DATA NO PADRAO ISO 8601
        const data = await ProvaService.dataatual();
        let dataServidor = data.data.dataatual
        let retorno = dataServidor.split(" ");
        let dt_prova = retorno[0] + 'T' + retorno[1] + 'Z';

        try {
         
            const data = await await ProvaService.gerarprova({ id_inscricao: id_inscricao, cd_vestibular: cd_vestibular, dt_prova: dt_prova });
           

            if (data.type) {
                setResponse(data.message.error);
                //console.log('ajajaj?', response, data.message.error, data.type)
                setError(true)
            } else {
                setTimeout(() => {
                    setRedirectToInicioProva(true);
                    

                }, 3000);
            }
        } catch (error) {
            setError(true)
        } 
        
    }

    const handleInicio = async (evt) => {
        let teste = localStorage.getItem('token');
        let dados = jwt(teste);
        const id_inscricao = dados.ID_Inscricao;
        // ** AJUSTE MASTER PARA FORMATAR DATA NO PADRAO ISO 8601
        {/* const data = await ProvaService.dataatual(); */}

        try {
            const inicio = await ProvaService.inicio(id_inscricao);
            localStorage.setItem('dadosInicio', JSON.stringify(inicio.data))
        } catch (error) {
            setError(true)
        }
        
    }

    if (redirectToInicioProva) {
        return <Redirect to={{ pathname: "/vestibular/iniciar" }} />
    }
    return (
        <Fragment>
            <form onSubmit={handleSubmit}>
                <Field>
                    <Control>
                        <Select.Container>
                            <Select id="selectID" className="input is-normal" onChange={selectChange}>
                                <Select.Option >Tipo Documento </Select.Option>
                                <Select.Option value="1">CPF</Select.Option>
                                <Select.Option value="2">Estrangeiro</Select.Option>
                            </Select>
                        </Select.Container>
                    </Control>
                </Field>
                {tcpf &&
                    <Field>
                        <Label size="small"></Label>
                        <Control >
                            <InputMask className="input is-normal"

                                placeholder="CPF"
                                value={cpf}
                                onChange={e => setCpf(e.target.value)}
                                required
                                name="cpf"
                                mask="999.999.999-99" />
                        </Control>
                    </Field>
                }
                {tdoc &&
                    <Field>
                        <Control>
                            <Input
                                className="input is-normal"
                                placeholder="Documento Estrangeiro"
                                type="number"
                                value={docEstrangeiro}
                                onChange={e => setDocEstrangeiro(e.target.value)}
                                required
                                name="doc_estrangeiro"
                            />
                        </Control>
                    </Field>
                }
                <Field>
                    <Control>
                        <InputMask
                            className="input is-normal"
                            placeholder="Data de Nascimento"
                            type="text"
                            value={dataNascimento}
                            onChange={e => setDataNascimento(e.target.value)}
                            required
                            name="dt_nascimento"
                            mask="99/99/9999" />
                    </Control>
                </Field>
                <Field>
                    <Button id="acessar" color="success">Realizar Prova Online</Button>
                </Field>
                {error && <Help color="danger">{response} {error}  </Help>}
            </form>
        </Fragment>
    )
}

export default LoginForm;